import { createHandler } from '@mews/std';
import { ActionType } from '@mews-commander/enums';
import { stubNull } from '@mews-commander/utils';
import ConfirmationDialogMenuItem from './menuItems/ConfirmationDialogMenuItem';
import LinkActionMenuItem from './menuItems/LinkActionMenuItem';
import ModalOpenerActionMenuItem from './menuItems/ModalOpenerActionMenuItem';
import { CustomMenuItem } from './menuItems/CustomMenuItem';

export default createHandler(
    {
        [ActionType.ModalOpener]: ({ action }: $TSFixMe) => (
            <ModalOpenerActionMenuItem {...action} key={action.url || action.key} />
        ),
        [ActionType.Link]: ({ action }: $TSFixMe) => <LinkActionMenuItem {...action} key={action.url || action.key} />,
        [ActionType.ConfirmationDialog]: ({ action, handleOpenDialog }: $TSFixMe) => (
            <ConfirmationDialogMenuItem
                {...action}
                handleOpenDialog={handleOpenDialog}
                key={action.url || action.key}
            />
        ),
        [ActionType.Custom]: ({ action }: $TSFixMe) => <CustomMenuItem {...action} key={action.key} />,
    },
    // @ts-expect-error $TSFixMeError: Argument of type '() => null' is not assignable to parameter of type '({ action, handleOpenDialog }: $TSFixMe) => JSX.El...
    stubNull
);
